import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-16d57ddc"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
import SearchInput from '@/components/SearchInput/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useI18n } from 'vue-i18n';
import { axiosInstanceAll } from '@/api/instance';
import { searchSubtitleApi } from '@/api/vodNew';
import { removePropertyOfNull } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {}
    },
    languageOptions: {
      type: Object,
      default: () => {}
    },
    programType: {
      type: String,
      default: 'movie'
    },
    languageSelect: {
      type: String,
      default: 'en'
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const multipleTable = ref();
    const searchInputRef = ref();

    const validatorDramaName = (rule, value, callback) => {
      if (value && !/^S[0-9][0-9]+E[0-9][0-9]+$/.test(value)) {
        callback(new Error(t('格式为S01E01')));
      } else {
        callback();
      }
    }; // 搜索框配置


    const searchConfig = reactive({
      formData: {
        sourceId: '',
        name: '',
        dramaName: '',
        language: ''
      },
      formList: [{
        label: 'IMDB ID',
        prop: 'sourceId',
        widgetType: 'input',
        placeholder: '请输入信息源ID',
        maxlength: 50
      }, {
        label: '影片名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入影片名称',
        maxlength: 50
      }, {
        label: '剧集名称',
        prop: 'dramaName',
        widgetType: 'input',
        placeholder: '请输入剧集名称',
        maxlength: 50,
        rules: [{
          validator: validatorDramaName,
          trigger: 'blur'
        }],
        controller: data => {
          return props.programType === 'movie' ? false : true;
        }
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        placeholder: '请选择语言',
        valueKey: 'code',
        filterable: true,
        list: props.languageOptions
      }]
    });
    const tableConfig = reactive({
      data: [],
      config: {
        loading: false
      },
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      'row-key': row => {
        return row.url;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: t('序号'),
        prop: '',
        type: 'index',
        width: 100
      }, {
        label: '名称',
        prop: 'name'
      }, {
        label: '语言',
        prop: 'language',
        width: 100
      }, {
        label: 'IMDB ID',
        prop: 'sourceId',
        width: 120
      }, {
        label: '字幕URL',
        prop: 'filePath',
        cellSlot: true
      }]
    });
    const selectTableConfig = reactive({
      selectData: []
    });
    const subtitleDialogConfig = reactive({
      visible: false,
      isShowHeader: false,
      data: [],
      paginationConfig: usePageConfig(),
      config: {
        title: '预览',
        loading: false
      },
      columnList: [{
        label: '序号',
        prop: 'id',
        width: 100
      }, {
        label: '起始时间',
        prop: 'startTime',
        width: 150
      }, {
        label: '结束时间',
        prop: 'endTime',
        width: 150
      }, {
        label: '字幕',
        prop: 'content'
      }]
    }); // 字幕搜索

    const getSearchSubtitle = async () => {
      try {
        tableConfig.config.loading = true;
        let params = {
          page: tableConfig.paginationConfig.page,
          limit: tableConfig.paginationConfig.limit,
          programType: props.programType,
          sourceId: searchConfig.formData.sourceId,
          name: searchConfig.formData.name,
          language: searchConfig.formData.language
        };
        props.programType === 'movie' ? '' : params.seriesEpisode = searchConfig.formData.dramaName;
        const res = await searchSubtitleApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.paginationConfig.total = res.data.total;
          tableConfig.data = res.data.records ? res.data.records : [];
          tableConfig.config.loading = false;
        } else {
          tableConfig.config.loading = false;
        }

        selectTableConfig.selectData.forEach(row => {
          multipleTable.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {
        tableConfig.config.loading = false;
      }
    }; // 查询点击事件


    const handleSearch = () => {
      searchInputRef.value.mForm.validate(valid => {
        if (valid) {
          getSearchSubtitle();
        }
      });
    }; // table复选框点击事件


    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    };

    const handleReset = () => {
      searchConfig.formData.name = props.formData.name;
      searchConfig.formData.language = props.languageSelect || 'en';
      getSearchSubtitle();
    };

    const subtitleData = ref([]); // 字幕URL item点击事件

    const subtitleItemClick = url => {
      return;
    };

    const getSubtitleInfo = url => {
      subtitleDialogConfig.config.loading = true;
      subtitleDialogConfig.data = [];
      subtitleDialogConfig.paginationConfig.page = 1;
      subtitleDialogConfig.paginationConfig.total = 0;

      try {
        axiosInstanceAll({
          url: '/subtitle/data' + url,
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          // console.log(res.data);
          // subtitleData.value = res.data.replace(/\n/g, '</br>')
          // subtitleData.value = res.data
          const dataList = []; // console.log(res.data.replace(/^([0-9]+:[0-9]+:[0-9]+,[0-9]+ --> [0-9]+:[0-9]+:[0-9]+,[0-9]+$)/gm, '$1content='));

          const asd = ('\n' + res.data).split(/\n\s*\r/gm); // console.log(asd);

          asd.forEach(item => {
            if (item.length > 2) {
              let itemArr = item.replace(/\r/g, '').split('\n'); // console.log(itemArr)

              dataList.push({
                id: itemArr[1],
                startTime: itemArr[2].split(' --> ')[0],
                endTime: itemArr[2].split(' --> ')[1],
                content: itemArr.slice(3).join(' ')
              });
            }
          }); // const idArr = res.data.match(/^[0-9]+$/gm)
          // const timeArr = res.data.match(/^[0-9]+:[0-9]+:[0-9]+,[0-9]+ --> [0-9]+:[0-9]+:[0-9]+,[0-9]+$/gm)
          // // console.log(idArr);
          // // console.log(timeArr);
          // idArr.forEach((id, index) => {
          //     dataList.push({
          //         id: id,
          //         startTime: timeArr[0].split('-->')[0],
          //         endTime: timeArr[0].split('-->')[1]
          //     })
          // })
          // console.log('dataList', dataList);

          subtitleData.value = dataList;
          subtitleDialogConfig.paginationConfig.total = dataList.length;
          returnAllPageFunc();
        }).catch(err => {
          console.log(err);
          subtitleDialogConfig.config.loading = false;
        });
      } catch (error) {
        subtitleDialogConfig.config.loading = false;
      }
    };

    const returnAllPageFunc = async () => {
      subtitleDialogConfig.config.loading = true;
      setTimeout(() => {
        let newArr = JSON.parse(JSON.stringify(subtitleData.value));
        subtitleDialogConfig.data = newArr.splice((subtitleDialogConfig.paginationConfig.page - 1) * subtitleDialogConfig.paginationConfig.limit, subtitleDialogConfig.paginationConfig.limit);
        subtitleDialogConfig.config.loading = false;
      }, 200);
    };

    watch(() => props.modelValue, val => {
      if (val) {
        tableConfig.data = [];
        tableConfig.paginationConfig = usePageConfig();
        selectTableConfig.selectData = [];
        searchConfig.formData.name = props.formData.name;
        searchConfig.formData.language = props.languageSelect || 'en';
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      selectTableConfig,
      multipleTable
    });
    return (_ctx, _cache) => {
      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(SearchInput, {
        labelWidth: "120px",
        ref_key: "searchInputRef",
        ref: searchInputRef,
        size: {
          sm: 24,
          md: 12,
          lg: 8,
          xl: 6,
          xs: 24
        },
        class: "search-input",
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, null, 8, ["form-list", "form-data"]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_common_table, {
        ref_key: "multipleTable",
        ref: multipleTable,
        "pagination-config": tableConfig.paginationConfig,
        render: getSearchSubtitle,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        onSelectionChange: handleSelectionChange,
        layout: "total, prev, pager, next, sizes"
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'filePath' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "pointer",
            onClick: $event => subtitleItemClick(scope.row.filePath)
          }, _toDisplayString(scope.row.filePath), 9, _hoisted_1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["pagination-config", "table-config"])])), [[_directive_loading, tableConfig.config.loading]]), _createVNode(_component_MDialog, {
        modelValue: subtitleDialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => subtitleDialogConfig.visible = $event),
        nativeConfig: {
          width: '60%'
        },
        dialogConfig: subtitleDialogConfig.config,
        onOnConfirm: subtitleDialogConfig.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(_component_common_table, {
          "pagination-config": subtitleDialogConfig.paginationConfig,
          render: returnAllPageFunc,
          style: {
            "width": "100%"
          },
          "table-config": subtitleDialogConfig,
          layout: "total, prev, pager, next, sizes"
        }, {
          default: _withCtx(() => [_createVNode(_component_column, {
            "column-list": subtitleDialogConfig.columnList
          }, null, 8, ["column-list"])]),
          _: 1
        }, 8, ["pagination-config", "table-config"])])), [[_directive_loading, subtitleDialogConfig.config.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});